import { render } from "./vouchers-generate.vue?vue&type=template&id=34fcb90a"
import script from "./vouchers-generate.vue?vue&type=script&lang=js"
export * from "./vouchers-generate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__